import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

import { COLOR_STROKE } from '../colors';

export const getMuiSkeletonDefaultProps = (theme: Theme): ComponentsProps['MuiSkeleton'] => ({
  animation: 'wave',
});

export const getMuiSkeletonOverrides = (theme: Theme): ComponentsOverrides['MuiSkeleton'] => ({
  root: {
    backgroundColor: COLOR_STROKE,
    opacity: 0.55,
  },
});
